(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadPosters(root) {
    root.querySelectorAll('video[data-poster]').forEach(function (video) {
      video.poster = video.dataset.poster;
      video.removeAttribute('data-poster');
    });
  }

  function watchPosters(root) {
    if (!('IntersectionObserver' in window)) {
      loadPosters(root);
      return;
    }
    var posterObserver = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      posterObserver.disconnect();
      loadPosters(root);
    }, { rootMargin: '600px 0px' });
    posterObserver.observe(root);
  }

  function setup(root) {
    var cards = root.querySelectorAll('.video-reels__card');
    if (!cards.length) return;

    watchPosters(root);

    var observer = null;
    if ('IntersectionObserver' in window && !reduceMotion) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.35 });
    }

    cards.forEach(function (card) {
      var video = card.querySelector('video');
      var button = card.querySelector('.video-reels__sound');
      if (!video) return;
      video.muted = true;
      if (observer) observer.observe(card);

      if (button) {
        button.addEventListener('click', function () {
          var unmuted = video.muted;
          root.querySelectorAll('video').forEach(function (v) { v.muted = true; });
          root.querySelectorAll('.video-reels__sound').forEach(function (b) {
            b.setAttribute('aria-pressed', 'false');
            b.setAttribute('aria-label', b.dataset.labelUnmute);
          });
          if (unmuted) {
            video.muted = false;
            button.setAttribute('aria-pressed', 'true');
            button.setAttribute('aria-label', button.dataset.labelMute);
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          }
        });
      }
    });
  }

  function init() {
    document.querySelectorAll('.video-reels').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.video-reels');
    if (root) setup(root);
  });
})();
